import { Table, TableHead, TablePagination, TableRow } from "@mui/material";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import { styled } from "@mui/material/styles";
import { tablePaginationClasses as classes } from "@mui/base/TablePagination";

export const StyledTableCell = styled(TableCell)(() => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "transparent",
    color: "#A4A4A4",
    fontFamily: "PoppinsMedium",
    fontSize: "clamp(10px, 4vw, 15px)",
  },
  [`&.${tableCellClasses.body}`]: {
    fontFamily: "PoppinsMedium",
    borderBottom: "0px solid #dedede",
    fontSize: "clamp(10px, 4vw, 12px)",
    color:"#FFF"
  },
}));

export const StyledTableHead = styled(TableHead)(() => ({
  "& .MuiTableCell-root": {
    backgroundColor: "#242424",
  },
}));

export const StyledWithdrawTableHead = styled(TableHead)(() => ({
  "& MuiTableHead-root": {
    backgroundColor: "#383636 !important",
  },
  "& .MuiTableRow-root": {
    backgroundColor: "#383636",
  },
  "& .MuiTableCell-root": {
    backgroundColor: "#383636",
  },
}));

export const StyledTableRow = styled(TableRow)(() => ({
  // hide last border
  "&:last-child td, &:last-child th": {
    border: 0,
    // borderBottom: "1px solid #dedede",
  },
  width: "100%",
}));

export const StyledWithdrawTableRow = styled(TableRow)(() => ({
  // hide last border
  "&:last-child td, &:last-child th": {
    border: 0,
  },
  width: "100%"
}));

export const CustomTablePagination = styled(TablePagination)(
  () => `
    & .${classes.spacer} {
      display: none; 
      font-family:"PoppinsMedium";
      color:#ffff
    }
  
    & .${classes.toolbar}  {
      display: flex;
      flex-direction: row;
      align-items: center;
      gap: 10px;
      background-color:transparent;
      justify-content: space-between; 
      border-bottom-left-radius: 6px;
      border-bottom-right-radius: 6px;    
      color:#ffff
  
    }
  
    & .${classes.selectLabel} {
      margin: 0;
      font-family:'PoppinsMedium'; 
      color:#ffff    
    }
  
    & .${classes.select}{
      padding: 2px 6px;
      border: none;
      border-radius: 6px;
      color:  #000;
      background-color:#FFF;
      font-family:'PoppinsMedium'; 
    }
  
    & .${classes.displayedRows} {
      margin: 0;
      font-family:'PoppinsMedium'; 
      color:#ffff
      }
    `
);
